import router from '@/router'
import { withInviteQuery } from '@/utils/channel'
import { isLoggedIn } from '@/utils/auth'

/** 站内登录页。已登录直接进账号页；register=true 时打开注册页签。 */
export function openLogin(options) {
  const target = isLoggedIn()
    ? { path: '/account' }
    : { path: '/login', query: withInviteQuery(options && options.register ? { tab: 'register' } : {}) }
  router.push(target).catch(() => {})
  window.scrollTo(0, 0)
}

/** iOS 不下载安装包，走网页注册后导入小火箭或 Clash 订阅 */
export function openIosLogin() {
  openLogin({ register: true })
}
